var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRecycling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.2 3.2 2.1 3.5H7.8L5.2 11 1.8 9l3.7-6.2a1.8 1.8 0 0 1 2.7.4Zm10.1 7.6-4.1.1 1.3-2.2-2.6-4.4 3.4-2 3.7 6.3a1.7 1.7 0 0 1-1.7 2.2ZM8 20.8l2-3.5 1.3 2.2h5.1v4H9a1.8 1.8 0 0 1-1-2.7ZM2.2 12.6l4.1.1L5 15l2.5 4.4-3.4 1.9-3.6-6.2a1.7 1.7 0 0 1 1.7-2.5Zm17.6.2 3.7 6.2a1.8 1.8 0 0 1-1.6 2.7h-7.3v-4h5.1l-1.3-2.2 1.4-2.7Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRecycling);
export default __webpack_public_path__ + "static/media/icon_recycling.1561e0ab2f66a1e69b36a8ac5f574f98.svg";
export { ForwardRef as ReactComponent };